import { useAtomValue } from 'jotai';
import { ReactNode } from 'react';
import { filterValueAtom } from '@/atoms/filters/filter';
import { FallbackNoData } from '@/components/visualisations/FallbackNoData';

const metricValueAtom = filterValueAtom('metric');

export const MetricKeyFallbackWrapper = ({
  children,
  fallback = <FallbackNoData />,
}: {
  children: ReactNode;
  fallback?: JSX.Element;
}) => {
  const metricKey = useAtomValue(metricValueAtom);

  return metricKey ? children : fallback;
};
